import axios from 'axios';

const axiosInstance = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    headers: {
        'Content-type': 'application/json',
    },
});

// token por defecto
axiosInstance.defaults.headers.common[
    'Authorization'
] = `Token 7f98472cc07fc974b99748e7b97a63e0f37c32f43bbef349b9406e631e3c47c6`;

export default axiosInstance;

export const setToken = (token) => {
    axiosInstance.defaults.headers.common['Authorization'] = `Token ${token}`;
};

export const CancelToken = axios.CancelToken;
